import React from "react";
import { THE_MUSE_SRC } from "config/constants.js";

class Careers extends React.Component {
  componentDidMount() {
    const scriptTag = document.createElement("script");
    scriptTag.src = THE_MUSE_SRC;
    this.bbEl.appendChild(scriptTag);
  }

  render() {
    return <div ref={bbEl => (this.bbEl = bbEl)} />;
  }
}

export default Careers;
